import { useState } from "react";
import { DialogTypeT } from "../types/ScheduleForm";

export function useDeliveryDialog() {
  const [openDialogType, setOpenDialogType] = useState<DialogTypeT>("");

  return { openDialogType, setOpenDialogType };
}
